import * as React from "react";

export const Table = React.forwardRef(({ className = "", ...props }, ref) => (
  <div className="w-full overflow-auto">
    <table ref={ref} className={`w-full caption-bottom text-sm ${className}`} {...props} />
  </div>
));
Table.displayName = "Table";

export const TableHeader = React.forwardRef(({ className = "", ...props }, ref) => (
  <thead ref={ref} className={`border-b border-white/10 ${className}`} {...props} />
));
TableHeader.displayName = "TableHeader";

export const TableBody = React.forwardRef(({ className = "", ...props }, ref) => (
  <tbody ref={ref} className={className} {...props} />
));
TableBody.displayName = "TableBody";

export const TableRow = React.forwardRef(({ className = "", ...props }, ref) => (
  <tr ref={ref} className={`border-b border-white/10 transition-colors hover:bg-white/5 ${className}`} {...props} />
));
TableRow.displayName = "TableRow";

export const TableHead = React.forwardRef(({ className = "", ...props }, ref) => (
  <th ref={ref} className={`h-12 px-4 text-left align-middle font-medium ${className}`} {...props} />
));
TableHead.displayName = "TableHead";

export const TableCell = React.forwardRef(({ className = "", ...props }, ref) => (
  <td ref={ref} className={`p-4 align-middle ${className}`} {...props} />
));
TableCell.displayName = "TableCell";
